import React from 'react';

import PurchasingModule from '../purchasing/components/PurchasingModule';
import InventoryPermissionGuard from './InventoryPermissionGuard';

export default function InventoryPurchasingModule() {
  return (
    <InventoryPermissionGuard
      permissions={[
        { resource: 'inventory.purchase', action: 'read' },
      ]}
    >
      <PurchasingModule />
    </InventoryPermissionGuard>
  );
}